import { Module } from "vuex"
import { IRootState } from "@/store/type"

export interface DictItem {
  key: string;
  value: any;
}

export interface IDictState {
  dict: DictItem[];
}

const dictModule: Module<IDictState, IRootState> = {
  namespaced: true,
  state() {
    return {
      dict: []
    }
  },
  mutations: {
    SET_DICT(state, { key, value }: { key: string, value: any }) {
      if (key !== null && key !== "") {
        state.dict.push({
          key: key,
          value: value
        })
      }
    },
    REMOVE_DICT(state, key: string) {
      try {
        for (let i = 0; i < state.dict.length; i++) {
          if (state.dict[i].key == key) {
            state.dict.splice(i, 1)
            return true
          }
        }
        return false;
      } catch (e) {
        return undefined;
      }
    },
    CLEAN_DICT(state) {
      state.dict = []
    }
  },
  actions: {
    // 设置字典
    setDict({ commit }, data: { key: string, value: any }) {
      commit("SET_DICT", data)
    },
    // 删除字典
    removeDict({ commit }, key: string) {
      commit("REMOVE_DICT", key)
    },
    // 清空字典
    cleanDict({ commit }) {
      commit("CLEAN_DICT")
    }
  }
}

export default dictModule